import { api } from '@/config/api';

export interface FbCreative {
  id: string;
  name: string;
  thumbnail_url?: string;
  image_url?: string;
  /**
   * Permanent ImageKit-hosted mirror of `thumbnail_url`. Prefer this when
   * rendering — Meta's signed CDN URLs expire in a few hours and
   * `thumbnail_url` will 403 after that. Populated by the backend on the
   * first sync of each creative.
   */
  imagekit_url?: string;
  media_kind: 'image' | 'video' | 'carousel' | 'unknown';
  headline?: string;
  description?: string;
  message?: string;
  link?: string;
  cta?: string;
  status?: string;
  created_time?: string;
}

export interface CarouselCardPayload {
  name: string;
  link: string;
  description?: string;
  image_url?: string;
  image_hash?: string;
  video_url?: string;
  call_to_action_type?: string;
}

export interface CreateAdCreativePayload {
  expected_account_uid?: string;
  name: string;
  link?: string;
  headline?: string;
  description?: string;
  message?: string;
  image_url?: string;
  image_hash?: string;
  video_url?: string;
  thumbnail_url?: string;
  thumbnail_image_hash?: string;
  call_to_action_type?: string;
  instagram_actor_id?: string;
  // Carousel
  child_attachments?: CarouselCardPayload[];
  multi_share_optimized?: string;
  /** Lead Gen form ID (Meta numeric ID). Set when running OUTCOME_LEADS to an Instant Form. */
  lead_gen_form_id?: string;
  /** Meta ad-set ID — backend inherits the Page from the ad set's promoted_object. */
  adset_id?: string;
  /** Explicit Page override (validated against the account's authorized pages). */
  page_id?: string;
}

export const facebookAdCreativesService = {
  list: async (refresh = false): Promise<{ data: FbCreative[]; paging?: unknown; fetchedAt: string; fromCache: boolean }> =>
    (await api.get('/slighter_crm/facebook/ad-creatives', { params: { refresh: refresh ? '1' : undefined } })).data,

  get: async (id: string, refresh = false): Promise<FbCreative> =>
    (await api.get(`/slighter_crm/facebook/ad-creatives/${id}`, { params: { refresh: refresh ? '1' : undefined } })).data,

  create: async (payload: CreateAdCreativePayload): Promise<{ id: string }> =>
    (await api.post('/slighter_crm/facebook/ad-creatives', payload)).data,
};
